import React from 'react';

type SkeletonAnimation = 'pulse' | 'wave' | 'none';

interface SkeletonCaseLoadListProps {
  itemCount?: number;
  animation?: SkeletonAnimation;
  hasAlertBadge?: boolean; // Randomly show the orange alert count badge on some rows
}

export const SkeletonCaseLoadList: React.FC<SkeletonCaseLoadListProps> = ({
  itemCount = 7,
  animation = 'wave',
  hasAlertBadge = true,
}) => {
  const itemIndexes = Array.from({ length: itemCount });

  return (
    <div className="skeleton-caseload-list">
      {itemIndexes.map((_, index) => (
        <div key={`caseload-item-${index}`} className="skeleton-caseload-item">
          <div className="line skeleton-caseload-caret" />
          <div className="line skeleton-caseload-avatar" />
          <div className="line skeleton-caseload-name" style={{ width: `${120 + ((index * 17) % 60)}px` }} />
          {hasAlertBadge && index % 3 !== 0 && (
            <div className="line skeleton-caseload-badge" />
          )}
          <div className="line skeleton-caseload-button" />
        </div>
      ))}
    </div>
  );
};

export default SkeletonCaseLoadList;
